import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';
import { Address } from "@models/address/address";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

type CellRendererParams = ICellRendererParams<unknown, Address[]>

@Component({
  selector: 'app-ag-addresses',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: 'ag-addresses.component.html',
  styles: `
    .grid-line-height {
      height: var(--ag-internal-padded-row-height);
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  `,
})
export class AgAddressesComponent implements ICellRendererAngularComp {
  @Input() set addresses(value: Address[]) {
    this.fillAddressStrings(value);
  }

  addressStrings = signal<string[][]>([]);

  agInit(params: CellRendererParams): void {
    this.updateCell(params);
  }

  refresh(params: CellRendererParams): boolean {
    return this.updateCell(params);
  }

  updateCell(params: CellRendererParams): boolean {
    this.fillAddressStrings(params.value ?? []);
    return true;
  }

  private fillAddressStrings(addresses: Address[]) {
    const addressStrings = addresses
      ?.filter(Boolean)
      ?.map((address) => {
        const secondLine = [
          address.suburb,
          address.region,
          address.state,
          address.postcode,
        ]
          .filter((string) => string?.trim())
          .join(' ');

        const firstLine = [
          address.line2,
          address.street,
        ]
          .filter((string) => string?.trim())
          .join(' ');

        return [
          firstLine,
          secondLine
        ]
          .filter((string) => string?.trim());
      }) ?? [];

    this.addressStrings.set(addressStrings);
  }
}
